import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "main__inner" }
const _hoisted_3 = {
  key: 0,
  class: "main__loader"
}
const _hoisted_4 = {
  key: 1,
  class: "main__content"
}
const _hoisted_5 = { class: "main__banner" }
const _hoisted_6 = { class: "main__form container" }
const _hoisted_7 = { class: "main__title" }
const _hoisted_8 = {
  key: 0,
  class: "main__catalogs"
}
const _hoisted_9 = {
  key: 1,
  class: "main__cards container"
}
const _hoisted_10 = {
  key: 2,
  class: "main__catalogs container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ap_loader = _resolveComponent("ap-loader")!
  const _component_main_banner = _resolveComponent("main-banner")!
  const _component_tele2_banner = _resolveComponent("tele2-banner")!
  const _component_altel_banner = _resolveComponent("altel-banner")!
  const _component_operator = _resolveComponent("operator")!
  const _component_transfer = _resolveComponent("transfer")!
  const _component_service_category = _resolveComponent("service-category")!
  const _component_discount_banner = _resolveComponent("discount-banner")!
  const _component_wallet_banner = _resolveComponent("wallet-banner")!
  const _component_service_card_container = _resolveComponent("service-card-container")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.mainLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_ap_loader)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.isDefault)
                    ? (_openBlock(), _createBlock(_component_main_banner, {
                        key: 0,
                        class: "main__default container"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isTele2)
                    ? (_openBlock(), _createBlock(_component_tele2_banner, {
                        key: 1,
                        class: "main__tele2"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isAltel)
                    ? (_openBlock(), _createBlock(_component_altel_banner, {
                        key: 2,
                        class: "main__altel"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isDefault)
                    ? (_openBlock(), _createBlock(_component_operator, {
                        key: 3,
                        class: "container"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('transfer')), 1),
                  _createVNode(_component_transfer)
                ]),
                (_ctx.isAltel || _ctx.isTele2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_service_category, { "from-main": "" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDefault)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_discount_banner, { class: "card" }),
                      _createVNode(_component_wallet_banner, { class: "card" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDefault)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_service_card_container, { services: _ctx.serviceList }, null, 8, ["services"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ])
    ]),
    _: 1
  }))
}